module.exports = __webpack_public_path__ + "img/yoozoo.8cb07d31.jpg";